// Geometry for the draggable OperationsTray chip: six dock points (the
// corners and side midpoints of the measured `.lro-dock-area`), fling
// projection, nearest-dock snapping, keyboard stepping and persistence.
// Docs: IMPLEMENTATION.md §Frontend Overlays.

export const DOCKS = [
  'top-left', 'top-right',
  'middle-left', 'middle-right',
  'bottom-left', 'bottom-right',
];
export const DEFAULT_DOCK = 'bottom-right';
const STORAGE_KEY = 'lroTrayDock';

// How far ahead (ms) a release velocity carries the chip before snapping:
// a flick toward a corner lands there even if released mid-screen.
const FLING_MS = 180;

export const dockParts = (dock) => {
  const [v, h] = dock.split('-');
  return { v, h };
};

/** Top-left pixel position of a `size`-square chip resting at `dock`. */
export const dockPosition = (dock, area, size) => {
  const { v, h } = dockParts(dock);
  const x = h === 'left' ? area.left : area.right - size;
  let y;
  if (v === 'top') y = area.top;
  else if (v === 'middle') y = area.top + (area.bottom - area.top - size) / 2;
  else y = area.bottom - size;
  return { x, y };
};

/** Where a released chip is headed: position plus velocity (px/ms) carry. */
export const projectFling = (pos, velocity) => ({
  x: pos.x + velocity.x * FLING_MS,
  y: pos.y + velocity.y * FLING_MS,
});

export const nearestDock = (pos, area, size) => {
  let best = DEFAULT_DOCK;
  let bestDist = Infinity;
  DOCKS.forEach((dock) => {
    const p = dockPosition(dock, area, size);
    const d = (p.x - pos.x) ** 2 + (p.y - pos.y) ** 2;
    if (d < bestDist) {
      bestDist = d;
      best = dock;
    }
  });
  return best;
};

const ROWS = ['top', 'middle', 'bottom'];

/** Arrow-key navigation between docks; returns the same dock at an edge. */
export const stepDock = (dock, key) => {
  const { v, h } = dockParts(dock);
  const row = ROWS.indexOf(v);
  if (key === 'ArrowLeft') return `${v}-left`;
  if (key === 'ArrowRight') return `${v}-right`;
  if (key === 'ArrowUp') return `${ROWS[Math.max(0, row - 1)]}-${h}`;
  if (key === 'ArrowDown') return `${ROWS[Math.min(ROWS.length - 1, row + 1)]}-${h}`;
  return dock;
};

export const loadDock = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return DOCKS.includes(raw) ? raw : DEFAULT_DOCK;
  } catch {
    return DEFAULT_DOCK;
  }
};

export const saveDock = (dock) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, dock);
  } catch {
    // Storage unavailable (private mode) — the chip just won't remember.
  }
};
